module.exports = __webpack_public_path__ + "assets/img/thumb-Solbari-Video.361766ab.jpg";